<template>
  <div>
    <v-text-field
      v-if="rules == null"
      ref="controlFoco"
      label="CUIT/CUIL"
      v-model="iModel"
      v-mask="'##-########-#'"
      :rules="[rulesInternas.cuitValido]"
      :readonly="readonly"
    ></v-text-field>
    <v-text-field
      v-else
      ref="controlFoco"
      label="CUIT/CUIL*"
      v-model="iModel"
      v-mask="'##-########-#'"
      :rules="[rulesInternas.requerido, rulesInternas.cuitValido]"
      :readonly="readonly"
    ></v-text-field>
  </div>
</template>

<script>
import { eventBus } from "@/main";
export default {
  name: "Cuit",
  props: {
    model: String,
    rules: {},
    readonly: Boolean
  },
  data() {
    return {
      itemActivo: {
        Cuit: ""
      },
      rulesInternas: {
        requerido: v => !!v || "Requerido",
        cuitValido: v => {
          return !v || this.validarCuit(v) || "No válido";
        }
      }
    };
  },
  watch: {
    model(valor) {
      this.itemActivo.Cuit = valor;
    }
  },
  computed: {
    iModel: {
      get() {
        return this.itemActivo.Cuit;
      },
      set(valor) {
        this.itemActivo.Cuit = valor;
        this.$emit("seleccionarItem", this.itemActivo);
      }
    }
  },
  created() {
    eventBus.$on("setearFocoCuit", this.setearFoco);
    eventBus.$on("inicializarCuit", this.inicializar);
  },
  beforeDestroy() {
    eventBus.$off("setearFocoCuit", this.setearFoco);
    eventBus.$off("inicializarCuit", this.inicializar);
  },
  methods: {
    setearFoco() {
      this.$refs.controlFoco.focus();
    },
    inicializar() {
      this.itemActivo.Cuit = "";
    },
    validarCuit(cuitConGuiones) {
      if (cuitConGuiones.length == 13) {
        var cuit = cuitConGuiones.replaceAll("-", "");
        var divisor = parseInt(cuit.substring(0, 1)) * 5;
        divisor += parseInt(cuit.substring(1, 2)) * 4;
        divisor += parseInt(cuit.substring(2, 3)) * 3;
        divisor += parseInt(cuit.substring(3, 4)) * 2;
        divisor += parseInt(cuit.substring(4, 5)) * 7;
        divisor += parseInt(cuit.substring(5, 6)) * 6;
        divisor += parseInt(cuit.substring(6, 7)) * 5;
        divisor += parseInt(cuit.substring(7, 8)) * 4;
        divisor += parseInt(cuit.substring(8, 9)) * 3;
        divisor += parseInt(cuit.substring(9, 10)) * 2;
        divisor += parseInt(cuit.substring(10)) * 1;
        var resto = divisor % 11;
        return resto == 0;
      } else return false;
    }
  }
};
</script>
